<template>
  <q-dialog v-model="show">
    <q-card style="padding: 15px; width: 360px">
      <p class="text-center">
        For <strong>{{ data.items.length }}</strong> vehicle(s),
        please pay <strong>{{ data.amount | formatPrice }}</strong>
      </p>
      <div class="row">
        <div class="col-8">
          <div>
            <q-btn color="secondary" class="btn q-mr-sm" :disabled="loading" :loading="loading">
              <template>
                <div>
                  <q-icon name="fas fa-lock" class="q-mr-sm"/>
                  <span class="q-gutter-md" @click.async="onSuccess()">
                    <span>Secure Payment</span>
                  </span>
                </div>
              </template>
            </q-btn>
          </div>
        </div>
        <div class="col-4">
          <div class="text-right">
            <q-btn type="button" color="red" label="CLOSE" @click="onClose"/>
          </div>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'SecurePaymentModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    onSuccess: {
      type: Function,
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
    }
  },
  methods: {
  },
}
</script>

<style scoped lang="scss">

</style>
